/* src/app/centrui/src/app/components/centrui-help-form/centrui-help-form.component.scss */
.menu-help-container {
  z-index: 10000000;
  width: 6.25rem;
  height: 6.25rem;
  border: none;
  border-left: 0.25rem solid transparent;
  border-top: 0.0625rem solid transparent;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  position: relative;
  background: transparent;
  padding: 0;
  transition: all 300ms cubic-bezier(0, 0.6, 0.4, 1);
}
.menu-help-container ::ng-deep svg-icon svg {
  height: 1.5rem !important;
  width: 1.5rem !important;
}
.menu-help-container ::ng-deep svg-icon {
  color: #1E31BF !important;
}
.menu-help-container ::ng-deep svg-icon svg :is(path, circle, rect, line, ellipse, polyline, polygon) {
  color: #1E31BF !important;
  stroke: #1E31BF !important;
}
.menu-help-container ::ng-deep svg-icon svg g {
  color: #1E31BF !important;
}
.menu-help-container ::ng-deep svg-icon svg g :is(circle, line) {
  stroke: #1E31BF !important;
}
.menu-help-container:hover {
  background-color: #F5F7FA;
  cursor: pointer;
}
.menu-help-container:focus,
.menu-help-container:focus-visible {
  outline: none;
}
.menu-help-container .menu-help-icon-wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.menu-help-container .help-survey-notification {
  position: absolute;
  top: -0.55rem;
  right: -0.55rem;
  width: 1.25rem;
  height: 1.25rem;
  pointer-events: none;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.menu-help-container .help-survey-notification path:first-of-type {
  fill: #F5B400;
  stroke: #F5B400;
  stroke-width: 2.25;
}
.menu-help-container .help-survey-notification path:not(:first-of-type) {
  fill: none;
  stroke: #FFFFFF;
  stroke-width: 2.25;
}
.help-form {
  z-index: 10000000;
  width: 22rem;
  display: flex;
  flex-direction: column;
  height: auto;
  min-height: 0;
  max-height: calc(90vh - 2rem);
  border: 0.0625rem solid #EBEBEB;
  border-radius: 0.5rem;
  background-color: #FFFFFF;
  font-family: "PoppinsMedium";
  font-size: 1rem;
  line-height: 125%;
  color: #757575;
  margin: auto;
  inset: auto auto 8.75rem 7.75rem;
  box-shadow: 0rem 0.1875rem 0.1875rem rgba(0, 0, 0, 0.13), 0rem 0.3125rem 0.625rem rgba(0, 0, 0, 0.09);
  position: fixed;
  overflow: visible;
  transition:
    width 350ms cubic-bezier(0.4, 0, 0.2, 1),
    height 350ms cubic-bezier(0.4, 0, 0.2, 1),
    max-height 350ms cubic-bezier(0.4, 0, 0.2, 1),
    inset 350ms cubic-bezier(0.4, 0, 0.2, 1),
    opacity 300ms ease,
    transform 300ms ease,
    display 300ms allow-discrete,
    overlay 300ms allow-discrete;
  opacity: 1;
  transform: translateX(0);
}
@starting-style {
  .help-form {
    opacity: 0;
    transform: translateX(-7rem);
  }
}
.help-form::after {
  content: "";
  position: absolute;
  bottom: 2.5rem;
  left: -0.75rem;
  width: 0.75rem;
  height: 1.25rem;
  background-color: #FFFFFF;
  clip-path: polygon(100% 0, 100% 100%, 0 50%);
  filter: drop-shadow(0rem 0.1875rem 0.1875rem rgba(0, 0, 0, 0.13)) drop-shadow(0rem 0.3125rem 0.625rem rgba(0, 0, 0, 0.09));
}
.help-form::before {
  content: "";
  position: absolute;
  bottom: 2.5rem;
  left: -0.85rem;
  width: 0.85rem;
  height: 1.35rem;
  background-color: #EBEBEB;
  clip-path: polygon(100% 0, 100% 100%, 0 50%);
  z-index: -1;
  filter: drop-shadow(0rem 0.1875rem 0.1875rem rgba(0, 0, 0, 0.13)) drop-shadow(0rem 0.3125rem 0.625rem rgba(0, 0, 0, 0.09));
}
.help-form.addin {
  max-width: 90vw;
  inset: 2rem auto auto 50%;
  transform: translateX(-50%);
}
@starting-style {
  .help-form.addin {
    opacity: 0;
    transform: translateX(calc(-50% + 12rem));
  }
}
.help-form.addin::before,
.help-form.addin::after {
  display: none;
}
.help-form.theme-lumi {
  position: static;
  width: 100%;
  inset: unset;
  border: none;
  border-radius: 0;
  box-shadow: none;
  margin: 0;
  padding: 0;
  max-height: none;
  transform: none;
  opacity: 1;
  overflow: visible;
}
.help-form.theme-lumi::before,
.help-form.theme-lumi::after {
  display: none;
}
.help-form.theme-lumi .help-form-body .help-form-content {
  padding: 0;
}
.help-form .help-form-body {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  overflow: visible;
}
.help-form .help-form-body .help-form-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  padding: 1.5rem;
  padding-bottom: 1rem;
  flex-shrink: 0;
}
.help-form .help-form-body .help-form-header .help-form-header-start {
  display: flex;
  align-items: center;
  min-width: 0;
}
.help-form .help-form-body .help-form-header .help-form-title {
  font-family: "PoppinsSemi Bold";
  font-size: 1.25rem;
  line-height: 1.5rem;
  color: #1E31BF;
}
.help-form .help-form-body .help-form-header .return-title {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
  gap: 0.15rem;
  margin-left: -0.5rem;
}
.help-form .help-form-body .help-form-header .return-title .return-icon {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
}
.help-form .help-form-body .help-form-header .return-title .return-icon ::ng-deep svg-icon svg {
  height: 1.5rem !important;
  width: 1.5rem !important;
}
.help-form .help-form-body .help-form-header .return-title .return-icon ::ng-deep app-centrui-icon {
  display: flex;
  align-items: center;
}
.help-form .help-form-body .help-form-header .return-title .return-icon ::ng-deep svg-icon {
  display: flex;
  align-items: center;
  width: 1.5rem;
  height: 1.5rem;
}
.help-form .help-form-body .help-form-header .return-title .return-icon ::ng-deep svg-icon svg {
  width: 1.5rem;
  height: 1.5rem;
}
.help-form .help-form-body .help-form-header .return-title .return-icon ::ng-deep svg-icon svg path {
  fill: #1E31BF !important;
  color: #1E31BF !important;
}
.help-form .help-form-body .help-form-header .return-title span {
  font-family: "PoppinsSemi Bold";
  font-size: 1rem;
  line-height: 1.25rem;
  color: #1E31BF !important;
}
.help-form .help-form-body .help-form-header .help-form-dismiss {
  text-align: right;
  background: none;
  border: none;
  padding: 0;
}
.help-form .help-form-body .help-form-header .help-form-dismiss ::ng-deep svg-icon svg {
  height: 1.25rem !important;
  width: 1.25rem !important;
}
.help-form .help-form-body .help-form-header .help-form-dismiss ::ng-deep svg-icon {
  color: #15141E !important;
}
.help-form .help-form-body .help-form-header .help-form-dismiss ::ng-deep svg-icon svg :is(path, circle, rect, line, ellipse, polyline, polygon) {
  color: #15141E !important;
  stroke: #15141E !important;
}
.help-form .help-form-body .help-form-header .help-form-dismiss ::ng-deep svg-icon svg g {
  color: #15141E !important;
}
.help-form .help-form-body .help-form-header .help-form-dismiss ::ng-deep svg-icon svg g :is(circle, line) {
  stroke: #15141E !important;
}
.help-form .help-form-body .help-form-header .help-form-dismiss {
  transition: all 300ms ease-in-out;
}
.help-form .help-form-body .help-form-header .help-form-dismiss:hover {
  cursor: pointer;
}
.help-form .help-form-body .help-form-header .help-form-dismiss:hover ::ng-deep svg-icon {
  color: #757575 !important;
}
.help-form .help-form-body .help-form-header .help-form-dismiss:hover ::ng-deep svg-icon svg :is(path, circle, rect, line, ellipse, polyline, polygon) {
  color: #757575 !important;
  stroke: #757575 !important;
}
.help-form .help-form-body .help-form-header .help-form-dismiss:hover ::ng-deep svg-icon svg g {
  color: #757575 !important;
}
.help-form .help-form-body .help-form-header .help-form-dismiss:hover ::ng-deep svg-icon svg g :is(circle, line) {
  stroke: #757575 !important;
}
.help-form .help-form-body .help-form-content {
  padding: 1.5rem;
  padding-top: 0;
  min-height: 0;
  max-height: calc(90vh - 12rem);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.help-form .help-form-body .help-form-content.tours,
.help-form .help-form-body .help-form-content.support {
  overflow-y: auto;
}
.help-form .help-form-body .help-form-content::-webkit-scrollbar {
  width: 0.25rem;
}
.help-form .help-form-body .help-form-content::-webkit-scrollbar-thumb {
  background: #1E31BF;
  border-radius: 0.25rem;
}
.help-form .help-form-body .help-form-content::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 0.25rem;
}
.help-form .help-form-body .help-form-content .help-buttons,
.help-form .help-form-body .help-form-content .help-tours-list {
  display: block;
}
.help-form .help-form-body .help-form-content .help-tours-list {
  max-height: 50vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.help-form .help-form-body .help-form-content .help-tours-list.scroll-locked {
  overflow-y: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.help-form .help-form-body .help-form-content .help-tours-list.scroll-locked::-webkit-scrollbar {
  display: none;
  width: 0;
  height: 0;
}
.help-form .help-form-body .help-form-content .help-option-item {
  display: block;
  width: 100%;
  background: #FFFFFF;
  border: 0.0625rem solid #EBEBEB;
  border-radius: 0.5rem;
  padding: 1rem;
  text-align: left;
  margin-bottom: 0.5rem;
  transition: background 300ms ease-in-out;
  font: inherit;
  color: inherit;
}
.help-form .help-form-body .help-form-content .help-option-item.overview {
  background: #1E31BF;
  border-color: #1E31BF;
}
.help-form .help-form-body .help-form-content .help-option-item.overview span {
  color: #FFFFFF;
}
.help-form .help-form-body .help-form-content .help-option-item.overview p {
  color: #FFFFFF;
}
.help-form .help-form-body .help-form-content .help-option-item.overview:hover {
  background: #1E31BF;
  cursor: pointer;
}
.help-form .help-form-body .help-form-content .help-option-item:last-child {
  margin-bottom: 0;
}
.help-form .help-form-body .help-form-content .help-option-item:hover {
  background: #F7F8FC;
  cursor: pointer;
}
.help-form .help-form-body .help-form-content .help-option-item span {
  font-family: "PoppinsBold";
  font-size: 1rem;
  line-height: 1.25rem;
  color: #1E31BF;
}
.help-form .help-form-body .help-form-content .help-option-item p {
  margin-top: 0.25rem;
  font-family: "PoppinsRegular";
  font-size: 0.675rem;
  line-height: 0.9375rem;
  color: #757575;
}
.help-form .help-form-body .help-form-content .help-empty-message {
  margin: 0;
  text-align: center;
  font-family: "PoppinsRegular";
  font-size: 0.75rem;
  color: #757575;
}
.help-form .help-form-body .help-form-content .help-tours-divider {
  border-top: 0.0625rem solid #EBEBEB;
  margin: 0.75rem 0;
}
.help-form .help-form-body .help-form-content .help-tours-search {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  height: 2rem;
  margin-bottom: 0.5rem;
  padding: 0 0.75rem;
  border: 0.0625rem solid #EBEBEB;
  border-radius: 0.5rem;
  background: #FFFFFF;
  transition: border-color 200ms ease-in-out;
}
.help-form .help-form-body .help-form-content .help-tours-search:focus-within {
  border-color: #1E31BF;
}
.help-form .help-form-body .help-form-content .help-tours-search .help-tours-search-icon {
  flex-shrink: 0;
}
.help-form .help-form-body .help-form-content .help-tours-search .help-tours-search-icon ::ng-deep svg-icon svg {
  height: 1.125rem !important;
  width: 1.125rem !important;
}
.help-form .help-form-body .help-form-content .help-tours-search .help-tours-search-icon ::ng-deep svg-icon {
  color: #757575 !important;
}
.help-form .help-form-body .help-form-content .help-tours-search .help-tours-search-icon ::ng-deep svg-icon svg :is(path, circle, rect, line, ellipse, polyline, polygon, g) {
  color: #757575 !important;
}
.help-form .help-form-body .help-form-content .help-tours-search .help-tours-search-icon ::ng-deep svg-icon svg :is(path, circle, rect, ellipse, polygon):not([stroke]):not([fill=currentColor]) {
  fill: #757575 !important;
}
.help-form .help-form-body .help-form-content .help-tours-search .help-tours-search-input {
  flex: 1;
  min-width: 0;
  height: 100%;
  padding: 0;
  border: none;
  background: transparent;
  outline: none;
  box-shadow: none;
  font-family: "PoppinsRegular";
  font-size: 0.875rem;
  line-height: 1.125rem;
  color: #757575;
}
.help-form .help-form-body .help-form-content .help-tours-search .help-tours-search-input::placeholder {
  color: #AAAAAA;
}
.help-form .help-form-body .help-form-content .help-form-buttons {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  margin-top: 1rem;
}
/*# sourceMappingURL=centrui-help-form.component.css.map */
